<template>
  <div>
	<div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
	
		<b-modal v-model="modalShow" ok-only centered centered class="text-center text-info">
		You are not logged in as a user or your email is not verified!
		</b-modal>
		<b-modal v-model="modalShow2" ok-only centered centered class="text-center text-info">
		Message Sent!
		</b-modal>
		<div class="wrap-slick1 rs1-slick1 shophome" id="home">
			<div class="slick1 shophome">
				<div class="item-slick1 shophome" :style="{ backgroundImage: 'url(' + homeimg + ')' }">
					<div class="container h-full">
						<div class="flex-col-l-m h-full p-t-0 p-b-30 m-p-t-00">
							
							<div class="">
								<h2 class="ltext-104 cl15 p-t-1 p-b-25 respon1 animated flip slower delay-3s">
									{{name}}
								</h2>
							</div>
								
								<div class="animated lightSpeedIn slower delay-2s p-b-12" >
								<span class="ltext-202 cl1 respon2 p-b-20">
									Open {{stime}} AM - Close {{etime}} PM
								</span>
							</div>
								
								<div class="animated lightSpeedIn slower delay-2s" v-if="tel1 != ''">
								<span class="ltext-202 cl1 respon2">
									Call Us +94 {{tel1}}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	 <!-- start banner Area -->
		<section class="banner-area relative m-t-70 m-b-50" >	
				<div class="overlay overlay-bg"></div>
				<div class="container" >				
					<div class="row d-flex align-items-center justify-content-center">
						<div class="about-content col-lg-12" >
							<h1 class="text-white" id="services">
								What We Offer				
							</h1>	
							
						</div>	
					</div>
				</div>
			</section>
			<!-- End banner Area -->

			<!-- Start service Area -->
			<section class="service-area section-gap" >
				<div class="container">
										
					<div class="row">
						<template v-for=" (service, i) in services" >
						<div class="col-lg-4 col-md-4" v-bind:key="service.title">
							<div class="single-service">
								<div class="thumb">
									<img :src="service.img" alt="" class="mt-4">									
								</div>
								<h4>{{service.title}}</h4>
								<p>
									{{service.desc}}
								</p>
							</div>
						</div>		
						</template>														
					</div>
				</div>	
			</section>
			<!-- End service Area -->

		<section class="banner-area relative m-t-70 m-b-50" >	
				<div class="overlay overlay-bg"></div>
				<div class="container" >				
					<div class="row d-flex align-items-center justify-content-center">
						<div class="about-content col-lg-12" >
							<h1 class="text-white" id="gallery">
								Our Gallery				
							</h1>	
							
						</div>	
					</div>
				</div>
			</section>
		<div class="container">
		<div class="row" style="height:auto;">
				<!-- :autoplay="true" :autoplay-timeout="5000" -->
				<carousel-3d style="height:auto !important;" :border="0" :controls-visible="true" :autoplay="true" :autoplay-timeout="2000">
				<slide :index="0" style="height:auto !important;" >
				<div :data-zoom="gallery[0]" class="zoom" v-if="gallery.length > 0">
				<img :src="gallery[0]" alt="">
				</div>
				</slide>	
				<slide :index="1" style="height:auto !important;" >
				<div :data-zoom="gallery[1]" class="zoom" v-if="gallery.length > 1">
				<img :src="gallery[1]" alt="">
				</div>
				</slide>
				<slide :index="2" style="height:auto !important;" >
				<div :data-zoom="gallery[2]" class="zoom" v-if="gallery.length > 2">
				<img :src="gallery[2]" alt="">
				</div>
				</slide>
				<slide :index="3" style="height:auto !important;" >
				<div :data-zoom="gallery[3]" class="zoom" >
				<img :src="gallery[3]" alt="" v-if="gallery.length > 3">
				</div>
				</slide>
				<slide :index="4" style="height:auto !important;" >
				<div :data-zoom="gallery[4]" class="zoom" v-if="gallery.length > 4">
				<img :src="gallery[4]" alt="">
				</div>
				</slide>
			</carousel-3d>	
		</div>
		<div class="row" style="height:auto;">
				<!-- :autoplay="true" :autoplay-timeout="5000" -->
				
			<carousel-3d style="height:auto !important;" :border="0" :controls-visible="true" :autoplay="true" :autoplay-timeout="2000" v-if="gallery.length > 5">
				<slide :index="0" style="height:auto !important;" >
				<div :data-zoom="gallery[5]" class="zoom" v-if="gallery.length > 5">
				<img :src="gallery[5]" alt="">
				</div>
				</slide>
				<slide :index="1" style="height:auto !important;" >
				<div :data-zoom="gallery[6]" class="zoom" v-if="gallery.length > 6">
				<img :src="gallery[6]" alt="">
				</div>
				</slide>
				<slide :index="2" style="height:auto !important;" >
				<div :data-zoom="gallery[7]" class="zoom" v-if="gallery.length > 7">
				<img :src="gallery[7]" alt="">
				</div>
				</slide>
				<slide :index="3" style="height:auto !important;" >
				<div :data-zoom="gallery[8]" class="zoom" v-if="gallery.length > 8">
				<img :src="gallery[8]" alt="">
				</div>
				</slide>
				<slide :index="4" style="height:auto !important;" >
				<div :data-zoom="gallery[9]" class="zoom" v-if="gallery.length > 9">
				<img :src="gallery[9]" alt="">
				</div>
				</slide>
				</carousel-3d>	
			</div>
				
			
			</div>
		 <div>
    <!-- Title page -->
			<section class="banner-area relative m-t-70 m-b-50" >	
				<div class="overlay overlay-bg"  ></div>
				<div class="container">				
					<div class="row d-flex align-items-center justify-content-center">
						<div class="about-content col-lg-12">
							<h1 class="text-white" id="about">
								Why We Are				
							</h1>	
							
						</div>	
					</div>
				</div>
			</section>
		
	<!-- Content page -->
	<section class="bg0  p-b-50" >
		<div class="container">
			<div class="row p-b-60">
				<div class="col-md-6">
					<div class="p-t-7 p-r-50 p-l-50 p-r-15-lg p-r-0-md">
						<h3 class="mtext-111 cl2 p-b-16">
							Our Story
						</h3>

						<p class="stext-113 cl6 p-b-26">
							{{about}}
						</p>

						<p class="stext-113 cl6 p-b-26" v-if="address != ''">
							Any questions? Let us know in our place at {{address}} or call us on +94{{tel1}}
						</p>
					</div>
				</div>

				<div class="col-11 col-md-5 m-lr-auto" v-if="aboutimg != undefined">
					<div class="how-bor1 " >
						<div class="hov-img0">
							<img :src="aboutimg" alt="">
						</div>
					</div>
				</div>
			</div>
			
		
		</div>
	</section>	
		

  </div>

		 <div>
	<!-- Title page -->
	
			<section class="banner-area relative m-t-50 m-b-20" >	
				<div class="overlay overlay-bg"></div>
				<div class="container">				
					<div class="row d-flex align-items-center justify-content-center">
						<div class="about-content col-lg-12">
							<h1 class="text-white" id="contact">
								Where We Are		
							</h1>	
							
						</div>	
					</div>
				</div>
			</section>
	


	<!-- Content page -->
	<section class="bg0 p-t-40 p-b-116">
		<div class="container">
			<div class="flex-w flex-tr">

				<div class="size-210 bor10 flex-w flex-col-m p-lr-93 p-tb-30 p-lr-15-lg w-full-md">
					<div class="">
					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-clock-o"></i>
						</span>

						<div class="size-212 p-t-2">
							<span class="mtext-110 cl2">
								Open - Close Time
							</span>

							<p class="stext-115 cl1 size-213 p-t-18">
								{{stime}} AM - {{etime}} PM
							</p>
							
						</div>
					</div>
					
					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-map-marker"></i>
						</span>

						<div class="size-212 p-t-2">
							<span class="mtext-110 cl2">
								Address
							</span>

							<p class="stext-115 cl6 size-213 p-t-18">
								{{address}}
							</p>
						</div>
					</div>

					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-phone"></i>
						</span>

						<div class="size-212 p-t-2">
							<span class="mtext-110 cl2">
								Lets Talk
							</span>

							<p class="stext-115 cl1 size-213 p-t-18" v-if="tel1 != ''">
								+94 {{tel1}}
							</p>
							<p class="stext-115 cl1 size-213 p-t-18" v-if="tel2 != ''">
								+94 {{tel2}}
							</p>
						</div>
					</div>

					<div class="flex-w w-full p-b-42">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-envelope"></i>
						</span>

						<div class="size-212 p-t-2">
							<span class="mtext-110 cl2">
								Services Support
							</span>

							<p class="stext-115 cl6 size-213 p-t-18">
								{{email}}
							</p>
						</div>
					</div>

					<!-- <div class="flex-w w-full">
						<span class="fs-18 cl5 txt-center size-211">
							<i class="fa fa-envelope"></i>
						</span>

						<div class="size-212 p-t-2">
							<span class="mtext-110 cl2">
								Web Site
							</span>

							<p><a :href="web" target="blank" class="stext-115 cl6 size-213 p-t-18">
								{{web}}
							</a></p>
						</div>
					</div> -->
				</div>
				</div>

				<div class="size-210 bor10 p-lr-70 p-t-55 p-b-70 p-lr-15-lg w-full-md">
					<div>
						<h4 class="mtext-105 cl2 txt-center p-b-30">
							Send Us A Message
						</h4>

						<div class="bor8 m-b-20 how-pos4-parent">
							<input class="stext-111 cl2 plh3 size-116 p-lr-28" type="text" v-model="cusname" placeholder="Your Name">
						
						</div>

						<div class="bor8 m-b-20 how-pos4-parent">
							<input class="stext-111 cl2 plh3 size-116 p-lr-28" type="number" v-model="phone" placeholder="Phone No">
						
						</div>

						<div class="bor8 m-b-30">
							<textarea v-model="msg" class="stext-111 cl2 plh3 size-120 p-lr-28 p-tb-25" maxlength="1500" placeholder="How Can We Help?"></textarea>
						</div>

						<button @click="sendMsg()" class="flex-c-m stext-101 cl0 size-121 bg3 bor1 hov-btn3 p-lr-15 trans-04 pointer">
							Submit
						</button>
					</div>
				</div>

				
			</div>
		</div>
	</section>

	<!-- <GmapMap
	v-if="load"
  :center="center"
  :zoom="18"
  
  class="mb-5 pb-5 mt-5"
  style="width: 100%; height: 500px">
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    @click="center=m.position"
  ></GmapMarker>
</GmapMap> -->


  </div>
  </div>
	  <div>
      	<!-- Footer -->
	<footer class="bg3 p-t-75 p-b-32">
		<div class="container">
			<div class="row">
				<div class=" col-sm-4 col-lg-4 p-b-20">
					<h4 class="stext-301 shopin cl0 p-b-30 f-font">
						eshops.lk
					</h4>

					<ul>
						<li class="p-b-10">
							<router-link :to="{name: 'home'}" class="stext-107 cl7 hov-cl1 trans-04">
								Home
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link :to="{name: 'startstore'}" class="stext-107 cl7 hov-cl1 trans-04">
								Start Store
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link :to="{name: 'about'}" class="stext-107 cl7 hov-cl1 trans-04">
								About Us
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link :to="{name: 'termsofuse'}" class="stext-107 cl7 hov-cl1 trans-04">
								Terms of Use
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link :to="{name: 'privacypolicy'}" class="stext-107 cl7 hov-cl1 trans-04">
								Privacy Policy
							</router-link>
						</li>
					</ul>
					<ul class="social-media-icons mb-2  d-inline">
              <li style=""><a href="https://www.facebook.com/Eshopslk-2212428785713128/" class="px-0 ml-0 mr-2 "><i class="fa fa-facebook-official  f-sm-link" style="font-size:34px; color:#3b5998; background-color:#fff; width: 30px; height: 30px; border-radius: 4px; text-align: center; vertical-align: middle;"></i></a></li>
              <li><a href="https://www.instagram.com/eshops.lk/" class="px-0 mx-2"><i class="fa fa-instagram  f-sm-link " style="font-size:30px; color:#fff; background: #d6249f;
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%); width: 32px; height: 32px; border-radius: 4px; text-align: center; vertical-align: middle;"></i></a></li>
              <li><a href="https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw" class="px-0 mx-2"><i class="fa fa-youtube-square  f-sm-link" style="font-size:35px; color:#FF0000;background-color:#fff; width: 30px; height: 30px; border-radius: 6px; text-align: center; vertical-align: middle;"></i></a></li>
            </ul>
				</div>

				<div class="col-sm-4 col-lg-4 p-b-20">
					<h4 class="stext-301 cl0 p-b-30 f-font">
						Business
					</h4>

					<ul>
						<li class="p-b-10">
							<a v-scroll-to="{
                            el: '#home', duration: 500,
                                easing: 'linear',
                            force: true,}" style="cursor:pointer;" class="stext-107 cl7 hov-cl1 trans-04 text-white">
								Home
							</a>
						</li>

						<li class="p-b-10">
							<a v-scroll-to="{
                            el: '#services', duration: 500,
                                easing: 'linear',
                            force: true,}" style="cursor:pointer;" class="stext-107 cl7 hov-cl1 trans-04 text-white">
								Services 
							</a>
						</li>
						<li class="p-b-10">
							<a v-scroll-to="{
                            el: '#gallery', duration: 500,
                                easing: 'linear',
                            force: true,}" style="cursor:pointer;" class="stext-107 cl7 hov-cl1 trans-04 text-white">
								Gallery 
							</a>
						</li>

						<li class="p-b-10">
							<a v-scroll-to="{
                            el: '#about', duration: 500,
                                easing: 'linear',
                            force: true,}" style="cursor:pointer;" class="stext-107 cl7 hov-cl1 trans-04 text-white">
								About
							</a>
						</li>

						<li class="p-b-10">
							<a v-scroll-to="{
                            el: '#contact', duration: 500,
                                easing: 'linear',
                            force: true,}" style="cursor:pointer;" class="stext-107 cl7 hov-cl1 trans-04 text-white">
								Contact
							</a>
						</li>
					</ul>
				</div>

				<div class=" col-sm-4 col-lg-4 p-b-30">
					<h4 class="stext-301 cl0 p-b-20 f-font">
						GET IN TOUCH
					</h4>

					<p class="stext-107 cl7 size-201">
						Any questions? Let us know in our place at {{address}} or call us on +94 {{tel1}}
					</p>
					 <div class="block-2 app-promotion">
					<a >
						<!-- Icon -->
					<img src="../../../static/img/icons/footer-android-chrome-76x76.png" alt="mobile-icon" class="mt-3 mb-2">
					</a>
					<p class="m-f-text text-white">Tap the Add to Home Screen Tab in Chrome Browser on Android or Safari Browser on IOS to Get the  Splendid <span style="color:#FD6A02;font-size:20px;">Mobile App</span> Directly</p>
					</div>

					<!-- <div class="p-t-16">
						<a href="#" class="fs-18 cl7 hov-cl1 trans-04 m-r-16">
							<i class="fa fa-facebook"></i>
						</a>

					</div> -->
				</div>

				<!-- <div class="col-sm-6 col-lg-3 p-b-50">
					<h4 class="stext-301 cl0 p-b-30">
						Newsletter
					</h4>

					<form>
						<div class="wrap-input1 w-full p-b-4">
							<input class="input1 bg-none plh1 stext-107 cl7" type="text" name="email" placeholder="email@example.com">
							<div class="focus-input1 trans-04"></div>
						</div>

						<div class="p-t-18">
							<button class="flex-c-m stext-101 cl0 size-103 bg1 bor1 hov-btn2 p-lr-15 trans-04">
								Subscribe
							</button>
						</div>
					</form>
				</div> -->
			</div>

			<div class="p-t-1">
				<div class="flex-c-m flex-w p-b-18">
					<a class="m-all-1">
						<img src="../../../static/img/eshops-logo.png" alt="eshops-logo">
					</a>

				</div>

				<p class="stext-107 cl6 txt-center">
					&copy; 2018 eshops.lk | All Rights Reserved
				</p>
			</div>
		</div>
	</footer>


	<!-- Back to top -->
	<div class="btn-back-to-top" id="myBtn">
		<span class="symbol-btn-back-to-top">
			<i class="fa fa-chevron-up"></i>
		</span>
	</div>

  </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from "firebase/app"
// import Banner from './Banner'

export default {
  name: 'home',
  components: {
	 
  },
   data (){
    return{
       latestItems: [],
        saleItems: [],
		bestSelling: [],
		loading:false,
		fetch:false,
		services:[],
		galleries:[],
		gallery:[],
		shops:[],
		name:'',
		homeimg:'',
		about:'',
		aboutimg:'',
		shopcats:{},
		cusname:'',
		msg:'',
		phone:'',
		modalShow:false,
		modalShow2:false,

		center: {  },
	 markers: [
		 {
			 position:{  },
		 }
	 ],
	 load:false,
	stime:'',
	etime:'',
	address:'',
	web:'',
	email:'',
	tel1:'',
	tel2:''

    }
	},
	methods:{
		 backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
	},
	sendMsg(){
		if(this.cusname != '' && this.msg != '' && this.phone != ''){
		if(firebase.auth().currentUser){
		db.collection('messages').add({
			owner:this.$route.params.pageid,
			email:firebase.auth().currentUser.email,
			phone:this.phone,
			notice: {
                  title:this.cusname,
                  msg:this.msg
            }
		}).then( () => {
			this.modalShow2 = true
			this.cusname = ''
			this.msg = ''
			this.phone = ''
			
		})
		  .catch(error => alert(error))
		}else{
			this.modalShow = true
		}
		}else{
			alert('Empty Fields!!!')
		}
	}
	},
   created () {
		 this.backToTop()
	  this.loading = true
		  this.fetch = false
		this.homeimg = '../../../static/images/ecommerce.jpg'
	   console.log('this.latestItems')
     
//   },

//  beforeCreate() {
	   console.log("home img")
	   
		  console.log('this.loading', this.loading)
			console.log("navigator.onLine", navigator.onLine)
		db.collection('services').where('owner', '==', this.$route.params.pageid)
		.onSnapshot(querySnapshot => {
       	 this.shops = []
     	 querySnapshot.forEach(doc => {
       		 const data = {
				'name': doc.data().name, 
				'details': doc.data().details,   
				'homeimg': doc.data().homeimg,
					'services': doc.data().services,
					'about': doc.data().about,
					'aboutimg':doc.data().aboutimg
        	}
				this.shops.push(data)
				console.log("homeimg is", this.shops[0].homeimg)
				if(this.shops[0].homeimg != undefined){
					this.homeimg = this.shops[0].homeimg
				}else{
					this.homeimg = '../../../static/images/ecommerce.jpg'
				}
			this.name = this.shops[0].name
			this.services = this.shops[0].services
			this.aboutimg = this.shops[0].aboutimg
			this.about = this.shops[0].about
			this.address = this.shops[0].details.address
			this.stime = this.shops[0].details.stime
			this.etime = this.shops[0].details.etime
			this.web = this.shops[0].details.web
			this.email = this.shops[0].details.email
			this.tel1 = this.shops[0].details.tel1
			this.tel2 = this.shops[0].details.tel2
			this.center.lat = this.shops[0].details.lat
			this.center.lng = this.shops[0].details.lng
			this.markers[0].position.lat = this.shops[0].details.lat
			this.markers[0].position.lng = this.shops[0].details.lng
			this.load = true
		 
			console.log("homeimg is", this.homeimg)
			console.log("name is", this.shops[0].name)
			console.log("details are", this.shops[0].details)
			 
	  })
	  
	})
			db.collection('galleries').where('owner', '==', this.$route.params.pageid).onSnapshot(querySnapshot => {
			this.galleries = []
			querySnapshot.forEach(doc => {
				const data = {
				'id': doc.id,
				'gallery':doc.data().gallery,
				
				
				}
				this.galleries.push(data)
				this.gallery = this.galleries[0].gallery
				console.log("gallery is", this.gallery)
			})
			})
		  //console.log("url is", this.url)
		    this.loading = false
		  this.fetch = true
	
  }

}
</script>

<style scoped>
@import url('~@/assets/main/css/loading.css');


@media (max-width: 575px){
	.m-txt{
		font-size: 12px;
		line-height: 1.0;
  		letter-spacing: 0px;
		color:#6c7ae0;
	}
	.m-p-t-00{
		padding-top: 100px;
	}
	.m-f-text{
    font-size: 12px;
  }
}
.shophome{
	height: 60vh !important;
}

.overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.banner-area {
    background: url(../../../static/images/banner-bg.jpg) center;
    background-size: cover;
}
.relative {
    position: relative;
}
.about-content {
    margin-top: 0px;
    padding: 25px 0px;
    text-align: center;
}

@media (max-width: 767px) {
    .about-content {
    margin-top: 0px;
}
.about-content h1 {
    font-size: 32px!important;
    font-weight: 600;
}
		.m-txt{
	  color:#6c7ae0;
	}
}
.about-content h1 {
    font-size: 48px;
    font-weight: 600;
}
.section-gap {
    padding: 0px 0;
}
.single-service h4 {
	color: #6c7ae0;
    padding: 20px 0;
    -webkit-transition: all 0.3s ease 0s;
    -moz-transition: all 0.3s ease 0s;
    -o-transition: all 0.3s ease 0s;
    transition: all 0.3s ease 0s;
    font-size: 17px;
}
.single-service:hover {
    cursor:default;
}
.single-service:hover h4 {
    color: #9844ff;
}
.single-service .thumb {
    overflow: hidden;
}
.single-service .thumb img {
    width: 100%;
    -webkit-transition: all 0.3s ease 0s;
    -moz-transition: all 0.3s ease 0s;
    -o-transition: all 0.3s ease 0s;
    transition: all 0.3s ease 0s;
}
.single-service:hover .thumb img {
    transform: scale(1.1) rotate(-2deg);
}
@media (max-width: 960px) {
    .single-service {
    text-align: center;
    margin-bottom: 30px;
}
}

.shopin{
	 text-transform: none;
 }
 .social-media-icons {
  text-align: center !important;
}

.social-media-icons li {
  display: inline-block;
}

.social-media-icons li a {
  color: #848484;
  padding: 0 15px;
}

.social-media-icons li a:hover {
  color: #fff !important;
  text-decoration: none;
}
.f-font{
	font-family: 'Poppins'
}
</style>




// WEBPACK FOOTER //
// src/components/store/Services.vue